export default __webpack_public_path__ + "static/media/micronaut-white-icon.1c3164ce.png";